"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepProgress = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var utils_1 = require("utils");
var Arrow_1 = require("./Arrow");
var Step_1 = require("./Step");
var StepProgress = function (_a) {
    var steps = _a.steps, className = _a.className, currentIndex = _a.currentIndex;
    return ((0, jsx_runtime_1.jsx)("ul", __assign({ className: (0, utils_1.concatStyles)(["flex", className]) }, { children: steps.map(function (step, i) { return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [i > 0 ? (0, jsx_runtime_1.jsx)(Arrow_1.Arrow, { disabled: currentIndex < i }, void 0) : null, (0, jsx_runtime_1.jsx)(Step_1.Step, { step: step.id, label: step.label, active: currentIndex === i, disabled: currentIndex < i }, void 0)] }, step.id)); }) }), void 0));
};
exports.StepProgress = StepProgress;
